// @ts-ignore
// import thinkingdata from "thinkingdata-browser";
// @ts-ignore
// const thinkingdata = dynamic(() => import("thinkingdata-browser"), { ssr: false }) as { init: any, track: any, setSuperProperties: any } | undefined;

// const config = {
//     appId: "7b422ab9aeb44285bc0edc3d48b5d305",
//     serverUrl: "https://uas.cmge.com/sync_js",
//     autoTrack: {
//         pageShow: true, //开启页面展示事件，事件名ta_page_show
//         pageHide: true, //开启页面隐藏事件，事件名ta_page_hide
//     }
// };
// thinkingdata?.init(config)
// window.ta = thinkingdata

// superProperties["channel"] = "ta";//字符串
// superProperties["age"] = 1;//数字
// superProperties["isSuccess"] = true;//布尔
// superProperties["birthday"] = new Date();//时间
// superProperties["object"] = { key:"value" };//对象
// superProperties["object_arr"] = [{ key:"value" }];//对象组
// superProperties["arr"] = ["value"];//数组
// ta.setSuperProperties(superProperties);//设置公共事件属性
function channelFn() {
  let r = document.referrer;
  let channel_name = '';
  if (r === '') {
    channel_name = '直接访问';
  } else if (
    r.indexOf('m.baidu.com/tc?') > 0 ||
    r.indexOf('baidu.com/link?') > 0
  ) {
    channel_name = '百度';
  } else if (
    r.indexOf('m.sogou.com/web/') > 0 ||
    r.indexOf('sogou.com/link?') > 0
  ) {
    channel_name = '搜狗';
  } else if (r.indexOf('m.so.com/s?') > 0 || r.indexOf('so.com/link?') > 0) {
    channel_name = '360搜索';
  } else if (r.indexOf('so.m.sm.cn') > 0) {
    channel_name = '神马搜索';
  } else if (r.indexOf('google.com') > 0 || r.indexOf('google.com.hk') > 0) {
    channel_name = '谷歌搜索';
  } else if (r.indexOf('cn.bing.com') > 0 && r.indexOf('?q=') < 0) {
    channel_name = '必应搜索';
  } else if (r.indexOf(window.location.hostname) > 0) {
    // 内部来源
    channel_name = '内部来源';
  } else {
    // 外部链接
    channel_name = '外部链接';
  }
  return channel_name;
}

const urlParams_user_origin = channelFn();
const createUUID = () => {
  let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

  return uuid;
};

const createWebUUID = () => {
  localStorage.setItem('bp_uuid', createUUID());
};

// 創建此次訪問的uuid (每次刷新均創新uuid)
export const getWebUUID = () => {
  if (typeof window === 'undefined') return;

  const uuid = window.localStorage.getItem('bp_uuid')
    ? localStorage.getItem('bp_uuid')
    : '';
  if (!uuid || uuid === '') createWebUUID();

  return window.localStorage.getItem('bp_uuid')
    ? localStorage.getItem('bp_uuid')
    : '';
};

const createXWWWFormUrlencoded = (data: any) => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');
};
//这个chat乱扯的错误的
export const getPlatformBrand = () => {
  let platform_type = 'Windows';
  const userAgent = navigator.userAgent;

  if (userAgent.indexOf('Windows') > -1) {
    platform_type = '微软';
  } else if (userAgent.indexOf('Mac') > -1) {
    platform_type = '苹果';
  } else if (userAgent.indexOf('Android') > -1) {
    if (userAgent.indexOf('Huawei') !== -1) {
      platform_type = '华为';
    } else if (
      userAgent.indexOf('Mi ') !== -1 ||
      userAgent.indexOf('Redmi') !== -1
    ) {
      platform_type = '小米';
    } else if (
      userAgent.indexOf('Samsung') !== -1 ||
      userAgent.indexOf('SM-') !== -1
    ) {
      platform_type = '三星';
    } else if (userAgent.match(/oppo/i)) {
      platform_type = 'OPPO';
    } else if (userAgent.match(/vivo/i)) {
      platform_type = 'VIVO';
    }
  } else if (userAgent.indexOf('iOS') > -1) {
    platform_type = '苹果';
  }

  return platform_type;
};

export const getPlatformType = () => {
  let platform_type = "Windows";
  const userAgent = navigator.userAgent.toLocaleLowerCase();

  if (userAgent.indexOf("windows") > -1) {

    platform_type = "Windows";

  } else if (userAgent.indexOf("iphone") > -1) {

    platform_type = "iOS";

  } else if (userAgent.indexOf("mac") > -1) {

    platform_type = "Mac";

  } else if (userAgent.indexOf("android") > -1) {

    platform_type = "Android";

  }

  return platform_type;
};

export const getPlatformVisitType = () => {
  
  let platform_type = "web";
  var userAgent = window.navigator.userAgent;
  userAgent = userAgent.toLocaleLowerCase()
  // 判断是否为手机设备
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
    // 手机设备
    if (userAgent.indexOf('android') > -1) {
      platform_type = 'Android';
    } else if (userAgent.indexOf('iphone') > -1 || /iphone|ipad|ipod/i.test(userAgent)) {
      platform_type = 'iOS';
    }
  } else {
    // 电脑设备
    if (userAgent.indexOf('win') > -1) {
      platform_type = 'Windows';
    } else if (userAgent.indexOf('mac') > -1) {
      platform_type = 'Mac';
    } else if (userAgent.indexOf('x11') > -1 || userAgent.indexOf('unix') > -1 || userAgent.indexOf('sunname') > -1 || userAgent.indexOf('bsd') > -1) {
      platform_type = 'Unix';
    } else if (userAgent.indexOf('linux') > -1) {
      platform_type = 'Linux';
    }
  }
  if (/MiniGame/i.test(userAgent)) {
    platform_type = 'mini';
  }

  return platform_type;
};

// 设置公参
export const reportEvent = (
  event: any, //事件名
  characteristic: any
) => {
  // console.log('[reportEvent]:', event, characteristic);
  var presetProperties = (window as any).ta?.getPresetProperties();

  //生成事件预置属性
  // var properties = presetProperties.toEventPresetProperties();
  /*
     {
       "#os":"Mac OS X",
       "#screen_width":1920,
       "#screen_height":1080,
       "#browser":"chrome",
       "#browser_version":"91.0.4472.114",
       "#device_id":"17a3858fafd9b4-0693d07132e2d1-34657600-2073600-17a3858fafea9b",
       "#zone_offset":8
     }
    */

  //获取某个预置属性
  // var os = presetProperties.os; //os类型，如Android
  // var screenWidth = presetProperties.screenWidth; //屏幕宽度
  // var screenHeight = presetProperties.screenHeight; //屏幕高度
  // var browser = presetProperties.browser; //浏览器类型
  var device_model = presetProperties.deviceModel; //设备型号 underfine

  // var browserVersion = presetProperties.browserVersion; //浏览器版本号
  var deviceId = presetProperties.deviceId; //设备ID
  // var zoneOffset = presetProperties.zoneOffset; //时区偏移值
  // var utm = presetProperties.utm; //时区偏移值

  const superProperties = {
    web_uuid: getWebUUID() || '',
    win_uuid: deviceId,
    platform_type: getPlatformType() || '', // 操作系统平台
    user_agent: navigator.userAgent,
    visit_type: getPlatformVisitType() || '', //访问端类型
    href: window.location.href,
    referrer: document.referrer ? document.referrer : window.location.href,
    user_origin: urlParams_user_origin || channelFn(), //用户来源
    phone: '',
    account_num: '',
    session_id: Math.random(), //会话id 非必传
    device_model: device_model || '', // 设备型号 小米/华为/OPPO等
    channel_sort: '',
  };

  let data = {
    ...superProperties,
    ...characteristic,
  };
  console.log('data', data);
  (window as any).ta?.track(event, data);
};

export const reportEventFrom = (
  phone: any //手机号码
) => {
  if (typeof window === 'undefined') return;

  const path = 'https://newoam.cmge.com/index/report/mediaIndex';

  let data = createXWWWFormUrlencoded({
    // 必传
    action: 'page_form',
    application_id: '7b422ab9aeb44285bc0edc3d48b5d305',
    logid_url: window.location.href,
    platform_type: getPlatformType(),
    //选传
    click_id: new Date().getTime(),
    phone: phone, //手机号
    form_type: '', //phone（传了手机号，则传phone。其他则不传） 不清楚是啥 有phone传phone，那这个字段的意义是？
    // @ts-ignore
    ext: JSON.stringify({
      pageCookie: `${Math.random() + getWebUUID()!}`,
      keywords: '',
      fromUrl: '',
    }), //扩展字段{"pageCookie":"6xxhhv6x4iyyyp1vpp","keywords":"","fromUrl":""} 其中，pageCookie 是按钮点击 去重用的
  });

  fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: data,
  })
    .then(response => response.json())
    .then(data => {
      // // conso.le.log(data)
    })
    .catch(error => {
      // // conso.le.log(error)
    });
};
const setSuperProperties = () => {
  if (typeof window === 'undefined') return;

  const superProperties = {
    // @ts-ignore
    web_uuid: getWebUUID(),
    win_uuid: '',
    platform_type: getPlatformType(), // 操作系统平台
    user_agent: navigator.userAgent,
    visit_type: '', //访问端类型
    href: window.location.href,
    referrer: document.referrer,
    user_origin: '', //用户来源
    phone: '',
    account_num: '',
    session_id: Math.random(), //会话id 非必传
    device_model: '', // 设备型号 小米/华为/OPPO等
    channel_sort: '',
  };
  if (typeof window !== 'undefined')
    (window as any).ta?.setSuperProperties(superProperties); //设置公共事件属性
};
setSuperProperties();
